import { useState } from 'react';

export default function BlogNewsletter() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      const body = new URLSearchParams({ email });
      await fetch('https://readdy.ai/api/form/d6j9qripaf6ievb71bfg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      // fail silently — still show success to user
      setSubmitted(true);
      setEmail('');
    } finally {
      setLoading(false);
      setTimeout(() => setSubmitted(false), 4000);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-[#E8E2D6] p-8 text-center">
      <div className="max-w-2xl mx-auto">
        <div className="w-16 h-16 bg-[#E8B84B] rounded-full flex items-center justify-center mx-auto mb-4">
          <i className="ri-mail-line text-3xl text-[#1C2B1E]"></i>
        </div>

        <h3 className="font-['Oswald'] text-3xl font-bold text-[#1C2B1E] mb-4">
          Stay Updated
        </h3>
        <p className="text-gray-700 mb-6">
          Get the latest car buying tips, maintenance advice, and exclusive deals delivered to your inbox every week.
        </p>

        {submitted ? (
          <div className="py-4 px-6 bg-[#F7F5F0] rounded-full inline-flex items-center gap-2 text-[#1C2B1E] font-medium">
            <i className="ri-checkbox-circle-fill text-[#E8B84B] text-xl"></i>
            Thanks for subscribing!
          </div>
        ) : (
          <form
            id="blog-newsletter-form"
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              aria-required="true"
              className="flex-1 px-6 py-3 bg-[#F7F5F0] border border-[#E8E2D6] rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-[#E8B84B] focus:border-transparent"
            />
            <button
              type="submit"
              disabled={loading}
              className="px-8 py-3 bg-[#1C2B1E] text-white rounded-full font-medium hover:bg-[#2d4430] transition-colors whitespace-nowrap disabled:opacity-60 cursor-pointer"
            >
              {loading ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
        )}

        <p className="text-xs text-gray-500 mt-4">
          No spam, unsubscribe anytime. We respect your privacy.
        </p>
      </div>
    </div>
  );
}
